module.exports = __webpack_public_path__ + "static/media/MuhammadAsif.827f6f62.jpeg";